/**
 * Utility to handle mobile viewport height issues
 * Sets CSS custom property for accurate viewport height on mobile devices
 */

export function initializeViewportHeight() {
  const setViewportHeight = () => {
    const viewportHeight = window.innerHeight
    document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`)
  }

  setViewportHeight()

  // Try to use Capacitor keyboard events on native for faster response
  try {
    const { Keyboard } = require('@capacitor/keyboard')
    Keyboard?.addListener('keyboardDidShow', setViewportHeight)
    Keyboard?.addListener('keyboardDidHide', setViewportHeight)
  } catch {
    // Fallback if Capacitor not available (web/PWA)
  }

  // Also listen to resize as fallback and for other viewport changes
  window.addEventListener('resize', setViewportHeight)

  // Handle orientation change with a small delay to ensure viewport has settled
  window.addEventListener('orientationchange', () => {
    setTimeout(setViewportHeight, 200)
  })
}
